import React from "react";
import { typeShell } from "../styles/typeShell";

const TYPE_ICON = {
    info: (
        <svg className="size-icon-control shrink-0 text-accent" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" /><rect x="9" y="8" width="2" height="6" rx="1" fill="currentColor" /><rect x="9" y="5" width="2" height="2" rx="1" fill="currentColor" /></svg>
    ),
    success: (
        <svg className="size-icon-control shrink-0 text-success" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" /><path d="M6 11l3 3 5-5" stroke="currentColor" strokeWidth="2" fill="none" /></svg>
    ),
    warning: (
        <svg className="size-icon-control shrink-0 text-warning" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" /><rect x="9" y="6" width="2" height="6" rx="1" fill="currentColor" /><rect x="9" y="14" width="2" height="2" rx="1" fill="currentColor" /></svg>
    ),
    error: (
        <svg className="size-icon-control shrink-0 text-error" fill="none" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" /><rect x="9" y="6" width="2" height="6" rx="1" fill="currentColor" /><rect x="9" y="14" width="2" height="2" rx="1" fill="currentColor" /></svg>
    ),
};

const TYPE_CLASS = {
    info: "border-l-accent bg-accent-10 text-accent-hover",
    success: "border-l-success bg-success-10 text-success",
    warning: "border-l-warning bg-warning-10 text-warning",
    error: "border-l-error bg-error-10 text-error",
};

function Toast({ id, type = "info", message, onClose, duration = 5000 }) {
    React.useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                onClose && onClose(id);
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [duration, onClose, id]);

    const typeClass = TYPE_CLASS[type] || TYPE_CLASS.info;

    return (
        <div
            className={`pointer-events-auto relative flex min-w-[240px] max-w-[360px] items-center gap-3 border-l-[4px] border-solid bg-surface px-4 py-3 shadow-none animate-toast-in ${typeShell.bodyMedium} ${typeClass}`}
            role="status"
        >
            <span className="flex shrink-0 items-center">{TYPE_ICON[type] || TYPE_ICON.info}</span>
            <span className="min-w-0 flex-1 break-words">{message}</span>
            {onClose && (
                <button
                    className="flex shrink-0 cursor-pointer items-center justify-center rounded border-none bg-transparent px-2 py-1 text-xl font-bold text-text-hint transition-colors hover:bg-border-subtle"
                    onClick={() => onClose(id)}
                    aria-label="閉じる"
                    type="button"
                >
                    <span className="material-symbols-outlined text-icon-control leading-none">
                        close
                    </span>
                </button>
            )}
        </div>
    );
}

export default Toast;
